import { ReactNode } from 'react';
import { useTranslation } from "@hmpu/powerups.intl.hooks.use-translation";

export const ConfigWritingDir = (props: { children: ReactNode }) => {
  console.log('ConfigWritingDir: RENDER');
  const { __t } = useTranslation();
  try {
    const dir = __t('direction', 'GENERAL');
    if(dir === 'ltr' || dir === 'rtl') {
      console.log('ConfigWritingDir: SETTING DIR ON DOM');
      document.querySelector('html').setAttribute('dir', dir);
    }
  } catch  (e) {
    console.error(e);
  }
  return props.children;
};

// v.0.0.1